import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import authModule from "../../../../../../../utilities/AuthModule";
import { GraphItemPIIRequest, PIIRequest, PIIResult } from "./api-local-interfaces";

const PII_API_URL = process.env.piiApiUri;

export const apiPiiSlice = createApi({
    reducerPath: 'api-pii',
    baseQuery: fetchBaseQuery({
        baseUrl: PII_API_URL,
        prepareHeaders: async (headers) => {     
            headers.set('XPII-API-KEY', authModule.getTenantApiKey());
			return headers;
		},
    }),
    endpoints: (builder) => ({
		checkPii: builder.mutation<PIIResult, PIIRequest>({
            query: (data) => ({
				url: `/pii`,
				method: 'POST',
				body: data,
			})
		}),
        graphItemPii: builder.mutation<PIIResult, GraphItemPIIRequest>({
            query: (data) => ({
				url: `/graphitempii`,
				method: 'POST',
				body: data,
			})
		})
    })
});

export const {
    useCheckPiiMutation,
    useGraphItemPiiMutation
} = apiPiiSlice;